(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name cycle.service:AdminCycleService
	 *
	 * @description
	 *
	 */
	angular.module('snap').service('AdminSnapService', AdminSnapService);

	function AdminSnapService(AdminSnapFactory, RemoteService,
			CommonMasterData) {

		var self = this;

		// store retrieved data
		var model = {
			snapDTO : AdminSnapFactory.getSnapDTO(),
			cycleSearchDTO : AdminSnapFactory.getCycleSearchDTO,
			snapSaveRequest : AdminSnapFactory.getCycleSaveRequest

		};

		self.getSnapDTO = function() {
			model.snapDTO = AdminSnapFactory.getSnapDTO();
			return model.snapDTO;
		};

		self.getAdaptedCycleSearchDTO = function(searchResponse) {
			model.cycleSearchDTO = AdminSnapFactory
					.getFormattedCycleSearchDTO(searchResponse);
			return model.cycleSearchDTO;
		};

		self.setSaveSnapeRequest = function(cycleSearchDTO) {
			model.snapSaveRequest = AdminSnapFactory.getFormattedSnapSaveRequest(cycleSearchDTO);
			return model.snapSaveRequest;
		};

		self.setSnapeScoreRequest = function(params){
            var snapScoreRequest = AdminSnapFactory.getSnapScoreRequest();
            snapScoreRequest.cycleId = params.selectedRow.cycleId;
            snapScoreRequest.crewType = params.crewType.crewTypeCode;
            snapScoreRequest.snapShotVersion = params.selectedRow.snapId;
            snapScoreRequest.scoreName = params.scoreVersion;
            return snapScoreRequest;
		};

        self.formatRestoreGridRequest = function(params){
            var restoreGridRequest = AdminSnapFactory.getRestoreGridRequest();
            restoreGridRequest.cycleId = params.cycleId;
            restoreGridRequest.crewType = params.crewType;
            restoreGridRequest.snapshotScoreId = params.snapshotScoreId;
            restoreGridRequest.loginId = null;
            return restoreGridRequest;
        };

		/**
		 * loadAdminCycles
		 *
		 * @param successFn
		 * @param errorFn
		 */
		self.loadRosterSnaps = function(showAll, successFn, errorFn) {
			RemoteService.loadRosterSnaps(showAll).then(function(response) {
				successFn(response);
			}, function(error) {
				errorFn(error.msg);
			});
		};


		self.scoreSnap = function(data, successFn, errorFn) {
			RemoteService.scoreSnap(data).then(function(response) {
				successFn(response);
			}, function(error) {
				errorFn(error.msg);
			});
		};

		/**
		 * saveAdminCycle
		 *
		 * @param successFn
		 * @param errorFn
		 */
		self.saveRosterSnap = function(saveCycleReq, successFn, errorFn) {
			RemoteService.saveRosterSnap(saveCycleReq).then(function(response) {
				successFn(response);
			}, function(error) {
				errorFn(error.msg);
			});
		};


		self.setScoreSnapeRequest = function(selectedRowData) {
			return AdminSnapFactory.setScoreSnapeRequest(selectedRowData);
		};

		self.scoreRosterSnap = function(data, successFn, errorFn){
			RemoteService.scoreSnap(data).then(function(response) {
				successFn(response);
			}, function(error) {
				errorFn(error.msg);
			});
		};

        self.restoreGridDuty = function(data, successFn, errorFn){
            RemoteService.restoreGridDuty(data).then(function(response) {
              successFn(response);
            }, function(error) {
              errorFn(error.msg);
            });
        };

	}
})();
